import React from 'react';
import { css } from '@emotion/css';

/**
 * @brief Renders the footer used in the first and the last page.
 */
const Footer = () => {
    // gets the current date as a string with format dd/mm/yyyy
    const currentDateString = new Date(Date.now()).toLocaleString().split(',')[0];

    return (
        <div
            className={css({
                display: 'flex',
                width: '100%',
                flexFlow: 'row',
                alignItems: 'flex-end',
                fontFamily: 'Proxima Nova',
                fontSize: '9.5pt',
                backgroundColor: 'white',
            })}
        >
            <div
                className={css({
                    textAlign: 'left',
                    width: '45%',
                    backgroundColor: 'white',
                })}
            >
                <b>Zellweger Management Consultants AG</b>
                <br />
                Schindellegistrasse 3<br />
                8808 Pfäffikon SZ, Schweiz
                <br />
                +41 (0)55 420 33 85 <br />
                ch@zellweger.com
            </div>
            <div
                className={css({
                    backgroundColor: 'white',
                    flexGrow: 1,
                    textAlign: 'center',
                })}
            >
                {currentDateString}
                <br />
                zellweger.com
            </div>
            <div
                className={css({
                    height: '15mm',
                    width: '45%',
                    textAlign: 'right',
                    backgroundColor: 'white',
                })}
            >
                <img
                    className={css({
                        height: '100%',
                        backgroundColor: 'white',
                    })}
                    src={process.env.PUBLIC_URL + '/logo.svg'}
                    alt="ZMC Logo"
                />
            </div>
        </div>
    );
};

export default Footer;
